import React from "react";
import swal from "sweetalert2";
import { ZipCodeTW } from "zipcode-tw-react";

class Address extends React.Component {
    constructor(props) {
        super(props);

        // 從 props 初始化地址
        const { initialAddress = "" } = props;
        const { county, district, zipCode, address } = this.parseAddress(initialAddress);

        this.state = {
            displayType: "text",
            county,
            district,
            zipCode,
            address,
        };
    }

    // 地址解析
    parseAddress = (fullAddress) => {
        const regex = /^(?<county>.+?[市縣])(?<district>.+?[鄉鎮市區])(?<zipCode>\d+)?(?<address>.*)$/;
        const match = fullAddress.match(regex);

        return {
            county: match?.groups?.county || "",
            district: match?.groups?.district || "",
            zipCode: match?.groups?.zipCode || "",
            address: match?.groups?.address || "",
        };
    };

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value }, this.returnCombinedAddress);
    };

    // 變更地址資訊
    handleZipCodeChange = (e) => {
        const { countyFieldName, countyValue, districtFieldName, districtValue, zipFieldName, zipValue } = e;
        this.setState(
            {
                [zipFieldName]: zipValue,
                [countyFieldName]: countyValue,
                [districtFieldName]: districtValue,
            },
            this.returnCombinedAddress
        );
    };

    // 處理郵遞區號不存在
    handleZipCodeNotExists = (e) => {
        const { origZipValue } = e;
        swal.fire({
            title: "郵遞區號不存在",
            text: `輸入的郵遞區號 (${origZipValue}) 無法匹配，請檢查後重試。`,
            icon: "error",
            confirmButtonText: "確定",
        });
    };

    // 組合並傳遞地址資訊給父元件
    returnCombinedAddress = () => {
        const { county, district, zipCode, address } = this.state;
        const combinedAddress = `${county}${district}${zipCode}${address}`;
        this.props.onAddressChange(combinedAddress);
    };

    render() {
        const { county, district, zipCode, address, displayType } = this.state;

        return (
            <div className="form-group">
                <div className="form-inline mb-2" style={{ display: "flex" }}>
                    <ZipCodeTW
                        displayType={displayType}
                        countyValue={county}
                        districtValue={district}
                        zipCodeValue={zipCode}
                        handleChangeCounty={this.handleZipCodeChange}
                        handleChangeDistrict={this.handleZipCodeChange}
                        handleChangeZipCode={this.handleZipCodeChange}
                        handleBlurZipCode={this.handleZipCodeChange}
                        handleZipCodeNotExists={this.handleZipCodeNotExists}
                    />
                </div>
                <input
                    name="address"
                    value={address}
                    className="form-control"
                    placeholder="輸入地址"
                    style={{ width: "100%" }}
                    onChange={this.handleChange}
                />
            </div>
        );
    }
}

export default Address;
